import { defineStore } from "pinia";
import IContext from "../../types/Ai/Text/IContext";

interface State {
  sectionIndex: null | number;
  columnIndex: null | number;
  blockIndex: null | number;
  blockId: null | string;

  promptText: string;

  contexts: Array<IContext>;

  loading: boolean;
}

export const useAiTextStore = defineStore("aiText", {
  state: (): State => ({
    blockIndex: null,
    columnIndex: null,
    promptText: "",
    sectionIndex: null,
    blockId: null,
    loading: false,
    contexts: [],
  }),

  actions: {
    setPromptText(prompt: string): void {
      this.promptText = this.cleanString(prompt);
    },

    cleanString(text: string): string {
      // Trim
      text = text.trim();

      // Remove HTML tags
      // text = text.replace(/<\/?[^>]+(>|$)/g, "");

      // Remove quotes
      // text = text.replace(/['"]+/g, "");

      // Remove newline characters from start and end of string
      // text = text.replace(/^\s+|\s+$/g, "");

      return text;
    },

    getContextByBlockId(blockId: string | null): IContext | undefined {
      return this.contexts.find((context) => context.blockId === blockId);
    },

    addMessageToBlockContext(
      blockId: string | null,
      prompt: string,
      answer: string
    ): void {
      const index = this.contexts.findIndex(
        (context) => context.blockId === blockId
      );

      if (index !== -1) {
        this.contexts[index].messages.push({
          prompt: prompt,
          answer: answer,
        });
        return;
      } else {
        const regex = /^.*?"([^"]*)".*?$/;
        const match = prompt.match(regex);

        let defaultText = null;

        if (match) {
          defaultText = match[1];
        } else {
          defaultText = prompt;
        }

        this.contexts.push({
          defaultText: defaultText,
          blockId: blockId,
          messages: [
            {
              prompt: prompt,
              answer: answer,
            },
          ],
        });
      }
    },

    addMessageToNewBlockContext(prompt: string, answer: string): void {
      this.addMessageToBlockContext(null, prompt, answer);
    },

    assignContextToNewBlock(newBlockId: string): void {
      const context = this.getContextByBlockId(null);
      if (context) {
        context.blockId = newBlockId;
        this.contexts.push(context);
      }
      this.resetNewBlockContext();
    },

    resetNewBlockContext(): void {
      this.contexts = this.contexts.filter(
        (context) => context.blockId !== null
      );
    },

    clearContext(): void {
      this.contexts = [];
    },
  },
});
